import { useMutation, useQueryClient } from '@tanstack/react-query';
import http from 'helpers/requests';

// Bare mutation without toast notifications — the form renders its own
// inline "Saved" feedback via FormActions. See useUpdateDeclarantSettings
// for the toast-emitting variant used by the Settings page.
export const useUpdateDeclarant = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (declarant) => {
      const response = await http.patch('/declarant', declarant);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['declarant'] });
    },
  });
};
